/** Face-grid sources. Body research lives on the animation catalog. */

export const EXPRESSION_SOURCES = [
  {
    role: 'Rows',
    title: 'Ekman',
    body: 'Ekman described a small set of basic emotions that hold across cultures. We take six of them as the human rows: happiness, sadness, anger, fear, surprise, and disgust. The rows added later sit on that same list.',
    cite: 'Ekman, P. (1992). An argument for basic emotions. Cognition & Emotion, 6(3–4), 169–200. Ekman, P., & Friesen, W. V. (1971). Constants across cultures in the face and emotion. Journal of Personality and Social Psychology, 17(2), 124–129.',
  },
  {
    role: 'Columns',
    title: 'Plutchik',
    body: 'Plutchik treated each emotion as something that changes in degree, from a mild form to an extreme one. The first four columns follow that scale: small, core, big, and out of control.',
    cite: 'Plutchik, R. (1980). A general psychoevolutionary theory of emotion. In R. Plutchik & H. Kellerman (Eds.), Emotion: Theory, research, and experience (Vol. 1, pp. 3–33). Academic Press.',
  },
  {
    role: 'Fifth column',
    title: 'Kelso',
    body: 'Kelso’s Matrix of Emotion keeps Ekman’s six and adds a fifth column, the feeling as it comes back down: anger settling toward amusement, fear toward bravery. The dashed border on this page marks that column.',
    cite: 'Kelso’s Choice. Matrix of Emotion [poster, GH5560]. Cerebellum Corporation.',
  },
  {
    role: 'Face codes',
    title: 'FACS and DogFACS',
    body: 'FACS names the muscle movements of a human face, and DogFACS does the same for a dog. Those codes stay on the cell so the face sentence can be checked against them. The sentence itself is written here. DogFACS has no disgust face, so that row is omitted.',
    cite: 'Ekman, P., & Friesen, W. V. (1978). Facial Action Coding System. Consulting Psychologists Press. Waller, B. M., Peirce, K., Caeiro, C. C., Scheider, L., Burrows, A. M., McCune, S., & Kaminski, J. (2013). Paedomorphic facial expressions give dogs a selective advantage. PLOS ONE, 8(12), e82686.',
  },
];
